<div class="confirmation">
  <p class="title">¿Aceptar estas condiciones?</p>
  <p class="question">Empezamos a financiar tus facturas con las condiciones que revisaste.</p>

  <div class="actions">
    <lib-ui-button
      variant="outline"
      size="l"
      [fullWidth]="false"
      label="Volver"
      (click)="cancel()"
    ></lib-ui-button>
    <lib-ui-button
      variant="filled"
      size="l"
      [fullWidth]="false"
      label="Aceptar condiciones"
      (click)="confirm()"
    ></lib-ui-button>
  </div>
</div>
